<template>
    <ul class="orders-gallery__thumbs-list">
        <li
            v-for="{ url, preview_url, id, created_at, created_by } in files"
            :key="id"
            class="orders-gallery__item"
        >
            <a target="_blank" :href="url">
                <div v-if="isVideo" class="orders-gallery__overlay">
                    <v-icon x-large color="#fff">mdi-play-circle</v-icon>
                </div>

                <img
                    :src="preview_url ? preview_url : url"
                    class="orders-gallery__img"
                    :alt="id"
                />

                <ul class="orders-gallery__img-info">
                    <li>
                        <p>
                            <DateCell :value="created_at" />
                        </p>
                    </li>
                    <li>
                        <p>{{ created_by || 'N/A' }}</p>
                    </li>
                </ul>
            </a>
            <v-btn
                v-if="
                    getAllowed([
                        'ADMIN',
                        roleUsaManagerAfterStartProduction,
                        'manager',
                    ]) && state !== 'Archived'
                "
                class="orders-gallery__btn-remove"
                color="#da4453"
                dark
                x-small
                @click="() => removeHandle(id)"
            >
                <v-icon x-small dark>mdi-close</v-icon>
            </v-btn>
        </li>
    </ul>
</template>

<script>
import { mapActions } from 'vuex'
import { actionTypes } from '@/store/modules/orders'
import { actionTypes as actionTypesModalNotifications } from '@/store/modules/modal-notifications'
import { actionTypes as actionTypesConfirmer } from '@/store/modules/confirmer'
import languageMixin from '@/mixins/language.mixin'

import DateCell from '@/components/common/cells/date-cell.vue'

export default {
    name: 'OrdersGalleryFilesList',
    components: {
        DateCell,
    },
    mixins: [languageMixin],
    props: {
        files: {
            type: Array,
            default: () => [],
        },
        state: {
            type: String,
            default: 'Draft',
        },
        isVideo: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {}
    },
    computed: {
        roleUsaManagerAfterStartProduction: function () {
            return this.state.toLowerCase() === 'draft' ? 'usa_manager' : ''
        },
    },
    methods: {
        ...mapActions('orders', {
            deleteFile: actionTypes.deletePhoto,
        }),
        ...mapActions('modalNotifications', {
            success: actionTypesModalNotifications.success,
        }),
        ...mapActions('confirmer', {
            confirmHandle: actionTypesConfirmer.confirmHandle,
        }),
        removeHandle: async function (id) {
            this.confirmHandle(
                this.$t('pages.wigPage.gallery.removeFile')
            ).then(() => {
                this.deleteFile(id).then(() => {
                    this.success(this.$t('pages.wigPage.gallery.fileRemoved'))
                })
            })
        },
    },
}
</script>

<style scoped lang="scss">
.orders-gallery {
    &__thumbs-list {
        display: grid;
        grid-template-columns: 1fr;
        gap: 16px;
        padding: 0;

        @include mobile-sm-up {
            grid-template-columns: repeat(2, 1fr);
        }

        @include tablet-up {
            grid-template-columns: repeat(2, 1fr);
        }

        @include desktop-xl-up {
            grid-template-columns: repeat(3, 1fr);
        }
        flex-wrap: wrap;
    }
    &__item {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
    }

    &__img {
        width: 100%;
        overflow: hidden;
        border-radius: 5px;
        cursor: pointer;
        object-fit: cover;
    }

    &__img-info {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        background: #fff;
        overflow: hidden;
        border-radius: 5px;
        padding: 4px 0;

        li {
            display: flex;
            justify-content: space-between;
            font-size: 11px;
            color: #000;
            flex-direction: column;
            padding: 0 8px;
            margin: 0;
        }

        p {
            padding: 0;
            margin: 0;
        }
    }

    &__btn-remove {
        position: absolute;
        right: 0;
        top: 5px;

        @include tablet-up {
            right: -10px;
        }
    }
    &__overlay {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.4);
        color: white;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        border-radius: 5px;
    }
}
</style>
